<template>
  <div class="flex items-center gap-2" data-testid="patient-unavailable">
    <VAvatar
      :size="avatarSize"
      color="grey-200"
      variant="outlined"
      class="ring-2 ring-white"
      data-testid="patient-unavailable-avatar"
    >
      <VIcon
        icon="person_off"
        class="material-icons-outlined"
        color="grey-500"
        :size="`${Math.round(avatarSize * 0.6)}px`"
      />
    </VAvatar>

    <p
      v-if="showLabel"
      class="text-sm text-gray-500 font-semibold"
      data-testid="patient-unavailable-label"
    >
      {{ t('Patient data unavailable') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { avatarSize = 40, showLabel = true } = defineProps<{
  avatarSize?: number
  showLabel?: boolean
}>()

const { t } = useI18n()
</script>
